import {
  Box,
  Button,
  CircularProgress,
  IconButton,
  Typography,
} from "@mui/material";
import { useFormik } from "formik";
import { useCallback, useState } from "react";

import AddCircleRoundedIcon from "@mui/icons-material/AddCircleRounded";
import * as yup from "yup";
import InputContainer from "../../components/InputContainer";
import Ask from "../../SVGs/Ask";
import InteractiveBook from "../../SVGs/InteractiveBook";
import Quiz from "../../SVGs/Quiz";
import Spinner from "./../../SVGs/Spinner";
import InteractiveFrom from "./components/InteractiveFrom";

const validationSchema = yup.object({});

const Interactive = ({ next, values, currentStep, loading }) => {
  const [DoneOpen, setDoneOpen] = useState(false);
  const openDone = useCallback((v) => setDoneOpen(v), []);
  const closeDone = useCallback(() => setDoneOpen(false), []);

  const [cover, setCover] = useState({ media: values?.cover || "" });
  const [poster, setPoster] = useState({ media: values?.poster || "" });

  const formik = useFormik({
    initialValues: {
      features: [
        {
          typeId: "",
          entityId: "",
          videoPause: false,
          duration: "",
          position: "",
          startTime: "",
        },
      ],
    },

    validationSchema: validationSchema,
    onSubmit: (vals) => {
      next({
        ...vals,
        cover,
        poster,
      });
    },
  });
  const deleteCover = () => setCover(null);
  const uploadCover = (e) => {
    const file = e?.target?.files[0];
    setCover({ file, media: URL.createObjectURL(file) });
  };

  const deletePoster = () => setPoster(null);
  const uploadPoster = (e) => {
    const file = e?.target?.files[0];
    setPoster({ file, media: URL.createObjectURL(file) });
  };

  return (
    <>
      {DoneOpen && (
        <InteractiveFrom
          open={DoneOpen}
          handleClose={closeDone}
          feature={formik.values.features}
        />
      )}
      <Box sx={{ width: 1 }}>
        <Box
          sx={{
            bgcolor: "#F8F8F8",
            px: 2,
            py: 1,
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            borderRadius: 3,
          }}
        >
          <Typography variant="body1" color={"#323232"}>
            1. Information
          </Typography>

          <img src={"/images/layout/Layer.png"} alt="Layer" width={"17px"} />
        </Box>
        <Box
          sx={{
            bgcolor: "#F8F8F8",
            px: 2,
            py: 1,
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            my: 2,
            borderRadius: 3,
          }}
        >
          <Typography variant="body1" color={"#323232"}>
            2. Interactive settings
          </Typography>
        </Box>
        <form onSubmit={formik.handleSubmit} style={{ width: "100%" }}>
          <InputContainer sx={{ my: 1 }}>
            {(!poster || !poster?.media) && (
              <Box
                item
                display="flex"
                justifyContent="center"
                alignContent="center"
                alignSelf="center"
                alignItems="center"
                className="pointer"
              >
                <label
                  style={{
                    height: "100%",
                    width: "100%",
                    paddingTop: " 5px",
                    paddingBottom: "5px",
                    backgroundColor: "#F4F5F7",
                  }}
                  className="pointer"
                >
                  <input
                    type="file"
                    onChange={(e) => uploadPoster(e)}
                    style={{ display: "none" }}
                    accept="image/*"
                  />
                  <Box sx={{ display: "flex", justifyContent: "center" }}>
                    <img src={"/images/uploadIcon.svg"} alt="" />
                    <Typography variant="body2" sx={{ mx: 1 }}>
                      upload poster
                    </Typography>
                  </Box>
                </label>
              </Box>
            )}
            <Box sx={{ textAlign: "start", width: 1 }}>
              {poster && poster?.media && (
                <>
                  <label
                    style={{ height: "100%", width: "100%" }}
                    className="pointer"
                  >
                    <input
                      type="file"
                      onChange={(e) => uploadPoster(e)}
                      style={{ display: "none" }}
                      accept="image/*"
                    />
                    {poster && poster?.media && (
                      <Box
                        sx={{
                          height: "156px",
                          position: "relative",
                        }}
                      >
                        <IconButton
                          sx={{
                            position: "absolute",
                            zIndex: "99",
                            right: 0,
                            color: "white",
                          }}
                          onClick={() => deletePoster()}
                        >
                          <img
                            loading="lazy"
                            src={"/images/closeIcon.svg"}
                            alt="addIcon"
                            height={20}
                          />
                        </IconButton>
                        <img
                          src={poster?.media}
                          alt=""
                          style={{
                            width: "100%",
                            height: "100%",
                            objectFit: "poster",
                            border: "1px solid #E9E9E9",
                            borderRadius: "16px",
                          }}
                        />
                      </Box>
                    )}
                  </label>
                </>
              )}
            </Box>
          </InputContainer>

          <InputContainer sx={{ my: 1 }}>
            {(!cover || !cover?.media) && (
              <Box
                item
                display="flex"
                justifyContent="center"
                alignContent="center"
                alignSelf="center"
                alignItems="center"
                className="pointer"
              >
                <label
                  style={{
                    height: "100%",
                    width: "100%",
                    paddingTop: " 5px",
                    paddingBottom: "5px",
                    backgroundColor: "#F4F5F7",
                  }}
                  className="pointer"
                >
                  <input
                    type="file"
                    onChange={(e) => uploadCover(e)}
                    style={{ display: "none" }}
                    accept="video/*"
                  />
                  <Box sx={{ display: "flex", justifyContent: "center" }}>
                    <img
                      src={"/images/layout/videos.png"}
                      alt=""
                      width={"100%"}
                    />
                  </Box>
                </label>
              </Box>
            )}
            <Box sx={{ textAlign: "start", width: 1 }}>
              {cover && cover?.media && (
                <>
                  <label
                    style={{ height: "100%", width: "100%" }}
                    className="pointer"
                  >
                    <input
                      type="file"
                      onChange={(e) => uploadCover(e)}
                      style={{ display: "none" }}
                      accept="video/*"
                    />
                    {cover && cover?.media && (
                      <Box
                        sx={{
                          height: "376px",
                          position: "relative",
                        }}
                      >
                        <IconButton
                          sx={{
                            position: "absolute",
                            zIndex: "99",
                            right: 0,
                            color: "white",
                          }}
                          onClick={() => deleteCover()}
                        >
                          <img
                            loading="lazy"
                            src={"/images/closeIcon.svg"}
                            alt="addIcon"
                            height={20}
                          />
                        </IconButton>
                        <video
                          src={cover?.media}
                          alt=""
                          controls
                          style={{
                            width: "100%",
                            height: "100%",
                            objectFit: "cover",
                            border: "1px solid #E9E9E9",
                            borderRadius: "16px",
                          }}
                        />
                      </Box>
                    )}
                  </label>
                </>
              )}
            </Box>
          </InputContainer>
          {cover?.media && (
            <Box
              sx={{
                px: 2,
                py: 3,
                bgcolor: "#f8f8f8",
                display: "flex",
                justifyContent: "start",
                alignItems: "center",
              }}
            >
              {formik.values.features?.map((e, i) => {
                return (
                  <Box>
                    {e?.typeId ? (
                      <Box
                        sx={{
                          display: "flex",
                          justifyContent: "center",
                          alignItems: "center",
                        }}
                      >
                        <IconButton
                          onClick={() => openDone({ features: e })}
                          sx={{
                            width: "50px",
                            height: "50px",
                            bgcolor: "#25AAE1",
                            p: 0,
                          }}
                        >
                          <Box
                            sx={{
                              fill: "#fff",
                              stroke: "#fff",
                              width: "32px",
                            }}
                          >
                            {
                              {
                                1: <Quiz />,
                                2: <Spinner />,
                                3: <InteractiveBook />,
                                4: <Ask />,
                              }[e?.typeId]
                            }
                          </Box>
                        </IconButton>
                        <Box
                          sx={{
                            width: "40px",
                            height: "3px",
                            bgcolor: "#43b6e5",
                          }}
                        ></Box>
                      </Box>
                    ) : (
                      <IconButton
                        onClick={() => openDone({ features: e })}
                        sx={{
                          width: "50px",
                          height: "50px",
                          bgcolor: "#fff",
                          p: 0,
                        }}
                      >
                        <AddCircleRoundedIcon
                          sx={{
                            color: "#e2e2e2",
                            width: "100%",
                            height: "100%",
                          }}
                        />
                      </IconButton>
                    )}
                  </Box>
                );
              })}
            </Box>
          )}

          <Box sx={{ backgroundColor: "#fff", width: 1, mt: 2 }}>
            <Button
              sx={{ p: 1, width: "20%" }}
              variant="outlined"
              color="error"
              onClick={() => currentStep("Information")}
            >
              Previous
            </Button>
            <Button
              type="submit"
              sx={{ p: 1, mx: 2, width: "20%" }}
              variant="contained"
              color="error"
              disabled={loading}
            >
              {loading ? (
                <CircularProgress />
              ) : (
                <Typography color={"white"}>submit</Typography>
              )}
            </Button>
          </Box>
        </form>
      </Box>
    </>
  );
};

export default Interactive;
